document.addEventListener('DOMContentLoaded', function () {
    const $button = $('#csv-download-button');
    const $link = $('#csv-download-link');
    let isDisabled = false;

    $link.on('click', function (e) {
        if (isDisabled) {
            e.preventDefault();
            return;
        }

        isDisabled = true;
        $link.addClass('disabled');
        $button.addClass('opacity-50');
    });
}); 